import {createActions} from 'redux-actions';
import profileActions from './profile.actions';
import {communityActions} from '../community';
import uuidv4 from 'uuid/v4';
import ReactGA from 'react-ga';
import fetchJson from '../fetchJson';
import handleError from '../handleError';

const actions = createActions(
	'EDITING_PROFILE_INIT',
	'EDITING_PROFILE_UPDATE',
	'EDITING_PROFILE_DONE'
);

export const init = () => (dispatch, getState) => {
	const provider = getState().profile;

	if (!provider) return;

	// Copy details from profile being viewed.
	dispatch(
		actions.editingProfileInit({
			uuid: provider.uuid,
			type: 'provider',
			profession: provider.profession,
			category: provider.category,
			profile: {
				brief: provider.profile.brief,
				about: provider.profile.about,
				backgroundImage: provider.profile.backgroundImage
			},
			user: {
				firstname: provider.user.firstname,
				lastname: provider.user.lastname,
				businessName: provider.user.businessName,
				location: {
					...provider.user.location
				}
			},
			subscriptionLevel: provider.subscriptionLevel
		})
	);
};

export const initCommunity = () => (dispatch, getState) => {
	const {community} = getState();

	if (!community) return;

	// Copy details from profile being viewed.
	dispatch(
		actions.editingProfileInit({
			uuid: community.uuid,
			type: 'community',
			category: community.category,
			profile: {
				brief: community.profile.brief,
				about: community.profile.about,
				backgroundImage: community.profile.backgroundImage,
				customColour: community.profile.customColour
			},
			name: community.name,
			location: {
				...community.location
			}
		})
	);
};

export const initNewCommunity = () => (dispatch, getState) => {
	// Copy details from profile being viewed.
	dispatch(
		actions.editingProfileInit({
			uuid: uuidv4(),
			type: 'community',
			profile: {
				uuid: uuidv4(),
				brief: '',
				about: ''
			},
			name: '',
			isNew: true
		})
	);
};

export const persist = () => (dispatch, getState) => {
	const editingProfile = getState().editingProfile;

	if (!editingProfile) return;

	ReactGA.event({
		category: 'Profile',
		action: 'Edit details'
	});

	const strippedData = {...editingProfile};
	if (!strippedData.isNew) {
		delete strippedData.uuid;
	}
	delete strippedData.type;
	delete strippedData.subscriptionLevel;

	if (editingProfile.type === 'provider') {
		dispatch(profileActions.persistProviderField(strippedData));
	} else if (editingProfile.type === 'community') {
		if (strippedData.isNew) {
			delete strippedData.isNew;
			dispatch(communityActions.persistNewCommunity(strippedData));
		} else {
			dispatch(communityActions.persistCommunityField(strippedData));
		}
	} else {
		throw Error('Unknown type');
	}

	dispatch(actions.editingProfileDone());
};

export const updateLocation = suburbUuid => (dispatch, getState) => {
	const editingProfile = getState().editingProfile;

	fetchJson(`/api/location/${suburbUuid}`)
		.then(location => {
			if (editingProfile.type === 'provider') {
				dispatch(actions.editingProfileUpdate({user: {location}}));
			} else if (editingProfile.type === 'community') {
				dispatch(actions.editingProfileUpdate({location}));
			} else {
				throw Error(`Unexpected user type ${editingProfile.type}`);
			}
		})
		.catch(handleError(dispatch));
};

export default {
	...actions,
	init,
	initCommunity,
	initNewCommunity,
	persist,
	updateLocation
};



// WEBPACK FOOTER //
// ./src/profile/editingProfile.actions.js